module.exports = __webpack_public_path__ + "img/電気回路_2_10_2.d70d0f33.png";